import { useState, useEffect } from 'react';
import { Services } from '@/services/services';
import { CurrentSession } from '@/services/repository/session';


export function useSession(services: Services) {
  const [session, setSession] = useState<CurrentSession | undefined | null>();

  useEffect(() => {
    services.session.loadSession().then((sess) => {
      setSession(sess)
    })
  }, [services])
 
  return session
}
